<div class="dashboard-shell">

  <!-- Profile banner -->
  <div class="dash-profile">
    <div class="dash-profile-bg"></div>

    <div class="dash-profile-left">
      <div class="dash-avatar">{{ (gS.userName || 'U') | slice:0:1 }}</div>
      <div class="dash-id">
        <span class="dash-hello">Welcome back</span>
        <h2 class="dash-name">{{ gS.userName || 'My Account' }}</h2>
        <p class="dash-sub" *ngIf="gS.userData?.email">
          <i class="fa-regular fa-envelope"></i> {{ gS.userData?.email }}
        </p>
        <p class="dash-sub" *ngIf="!gS.userData?.email">Manage your profile, orders &amp; activity</p>
      </div>
    </div>

    <div class="dash-profile-right">
      <div class="dash-wallet">
        <span class="dash-wallet-label"><i class="fa-solid fa-wallet"></i> Wallet Balance</span>
        <span class="dash-wallet-amt">{{ gS.currencySign }} {{ gS.userBalance || 0 }}</span>
        <a routerLink="/recharge-wallet" class="dash-wallet-btn">
          <i class="fa-solid fa-plus"></i> Recharge
        </a>
      </div>
      <button type="button" class="dash-logout" (click)="logout()">
        <i class="fa-solid fa-right-from-bracket"></i>
        <span>Logout</span>
      </button>
    </div>
  </div>

  <!-- Navigation -->
  <nav class="dash-nav">
    <ng-container *ngFor="let item of menuItem">
      <a *ngIf="item?.isMenuActive" class="dash-nav-link" routerLink="/{{ item.routerLink }}"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <span class="dash-nav-ico"><i [class]="item.icon"></i></span>
        <span class="dash-nav-txt">{{ item.name }}</span>
      </a>
    </ng-container>
  </nav>

</div>
